import type { Ticket } from '@trmediaab/zebra-types/trhub';

import InfoCard from '../../components/Card/InfoCard';

interface TicketCardProps {
  ticket: Ticket;
}

const TicketCard = ({ ticket }: TicketCardProps) => (
  <InfoCard
    title="Dina klippkort"
    body={
      <>
        Du har {ticket.remaining} omgångar kvar på ditt klippkort: {ticket.name}
        , {ticket.punches} omgångar
      </>
    }
  />
);

export default TicketCard;
